import { useTranslation } from "next-i18next";

import { Icon } from "@/components/elements/Icon";
import { Text } from "@/components/elements/Text";

import styles from "./styles.module.css";

type NotificationSuccessProps = {
  ns: string;
  copy: string;
};

export const NotificationSuccess = ({ copy, ns }: NotificationSuccessProps) => {
  const { t } = useTranslation(ns);

  return (
    <div className={styles.container}>
      <Icon type="checkmark_circle" />
      <Text className={styles.copy} size="xs">
        {t(copy)}
      </Text>
    </div>
  );
};
